import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  CircularProgress,
  Pagination,
  Typography,
  Box,
} from "@mui/material";
import { Visibility, Edit, Delete } from "@mui/icons-material";
import { motion } from "framer-motion";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTheme, useMediaQuery } from "@mui/material";
import ImageZoomDialog from "../../Components/AlertDialog/ImageZoomDialog";

const UploadReportsTable = ({
  loading,
  reports,
  handleEditData,
  handleDeleteData,
}) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState("");

  const filteredData = reports.filter((row) =>
    row.user?.fname?.toLowerCase().includes(search.toLowerCase())
  );

  console.log(reports);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const openPDF = (base64) => {
    const byteCharacters = atob(base64.split(",")[1]);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobURL = URL.createObjectURL(blob);

    window.open(blobURL, "_blank");
  };

  return (
    <Paper elevation={3} sx={{ padding: 2, borderRadius: 3, width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 16,
        }}
      >
        <TextField
          label="Search by Customer Name"
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {isSmallScreen ? (
            <></>
          ) : (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "#1976d2" }}>
                    <TableRow>
                      <TableCell sx={{ color: "#fff" }}>S.No.</TableCell>
                      <TableCell sx={{ color: "#fff" }}>
                        Customer Name
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }}>Description</TableCell>
                      <TableCell sx={{ color: "#fff" }}>File</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
              </TableContainer>
            </>
          )}
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <CircularProgress />
          </div>
        </motion.div>
      ) : filteredData.length === 0 ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          style={{ textAlign: "center", padding: "40px 0", fontWeight: "bold" }}
        >
          No Data Found
        </motion.div>
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {isSmallScreen ? (
            <>
              {" "}
              <Box display="flex" flexDirection="column" gap={2}>
                {paginatedData.map((row, index) => (
                  <Paper
                    key={row.id}
                    elevation={2}
                    sx={{
                      padding: 2,
                      backgroundColor: row.is_admin === 1 ? "#d0f0c0" : "#fff",
                      borderRadius: 2,
                    }}
                  >
                    <Typography fontWeight="bold" gutterBottom>
                      {row.user?.fname || "N/A"}
                    </Typography>
                    <Typography>
                      Description: {row.description || "N/A"}
                    </Typography>
                    <Typography>
                      Report Name: {row.reportName || "N/A"}
                    </Typography>{" "}
                    <Typography>
                      Pain Areas: {row.item_name || "N/A"}
                    </Typography>
                    <Box mt={1}>
                      {row.file_base64?.startsWith("data:application/pdf") ? (
                        <IconButton onClick={() => openPDF(row.file_base64)}>
                          <PictureAsPdfIcon
                            sx={{ fontSize: 28, color: "red" }}
                          />
                        </IconButton>
                      ) : row.file_base64 ? (
                        <img
                          src={row.file_base64}
                          onClick={() => {
                            setSelectedImageUrl(row.file_base64);
                            setImageDialogOpen(true);
                          }}
                          alt="report"
                          style={{
                            width: "100%",
                            maxHeight: 200,
                            objectFit: "contain",
                            borderRadius: 4,
                          }}
                        />
                      ) : (
                        "No File"
                      )}
                    </Box>
                    <Box mt={2} display="flex" gap={1}>
                      <IconButton
                        color="secondary"
                        onClick={() => handleEditData(row)}
                      >
                        <Edit />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => handleDeleteData(row)}
                      >
                        <Delete />
                      </IconButton>
                    </Box>
                  </Paper>
                ))}
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 16,
                }}
              >
                <Pagination
                  count={Math.ceil(filteredData.length / rowsPerPage)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </div>
            </>
          ) : (
            <>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ backgroundColor: "#1976d2" }}>
                    <TableRow>
                      <TableCell sx={{ color: "#fff" }}>S.No.</TableCell>
                      <TableCell sx={{ color: "#fff" }}>
                        Customer Name
                      </TableCell>
                      <TableCell sx={{ color: "#fff" }}>Description</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Report Name</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Pain Areas</TableCell>
                      <TableCell sx={{ color: "#fff" }}>File</TableCell>
                      <TableCell sx={{ color: "#fff" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={
                          row.is_admin === 1
                            ? { backgroundColor: "#d0f0c0" }
                            : {}
                        }
                      >
                        <TableCell>
                          {(page - 1) * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell>{row.user?.fname || "N/A"}</TableCell>
                        <TableCell>{row.description || "N/A"}</TableCell>
                        <TableCell>{row.reportName || "N/A"}</TableCell>
                        <TableCell>{row.item_name || "N/A"}</TableCell>
                        <TableCell>
                          {row.file_base64?.startsWith(
                            "data:application/pdf"
                          ) ? (
                            <IconButton
                              onClick={() => openPDF(row.file_base64)}
                            >
                              <PictureAsPdfIcon
                                sx={{ fontSize: 28, color: "red" }}
                              />
                            </IconButton>
                          ) : row.file_base64 ? (
                            <img
                              src={row.file_base64}
                              onClick={() => {
                                setSelectedImageUrl(row.file_base64);
                                setImageDialogOpen(true);
                              }}
                              alt="report"
                              style={{
                                width: 40,
                                height: 40,
                                objectFit: "cover",
                                borderRadius: 4,
                              }}
                            />
                          ) : (
                            "No File"
                          )}
                        </TableCell>

                        <TableCell>
                          {/* <IconButton color="primary">
                        <Visibility />
                      </IconButton> */}
                          <IconButton
                            color="secondary"
                            onClick={() => handleEditData(row)}
                          >
                            <Edit />
                          </IconButton>

                          <IconButton
                            color="error"
                            onClick={() => handleDeleteData(row)}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingTop: 16,
                }}
              >
                <Pagination
                  count={Math.ceil(filteredData.length / rowsPerPage)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </div>
            </>
          )}
        </motion.div>
      )}
      <ImageZoomDialog
        open={imageDialogOpen}
        onClose={() => setImageDialogOpen(false)}
        imageUrl={selectedImageUrl}
      />
    </Paper>
  );
};

export default UploadReportsTable;
